{
  "version": 1,
  "asset_id": "fa2b214d-f841-4065-be90-649b200a4a3e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/fa2b214d-f841-4065-be90-649b200a4a3e/mark-384.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/fa2b214d-f841-4065-be90-649b200a4a3e/mark-384.avif",
  "original_filename": "mark-384.avif",
  "size": 9647,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:28Z"
}
